const getURL = (api) => `/vsp/admin/${api}`;

export const API_LOGIN = 'vsp/auth/login';
export const API_LOGOUT = 'vsp/auth/logout';
export const API_PING = 'vsp/auth/ping';
export const WHOAMI = getURL('whoami');
export const API_GRANTS = getURL('grants');
export const API_ORGS = getURL('orgs');
export const API_ORGS_ALL = getURL('orgs/org/all');
export const API_ORG_DETAILS = getURL('orgs/org');
export const API_ORG_USERS = getURL("orgs/org/users");
export const API_ORG_ISSUES = getURL("orgs/org/issues");
export const API_ORGS_CONTRACTS = getURL("orgs/org/contracts");
export const API_ORG_CONTRACT = getURL("orgs/org/contracts/contract");
export const API_ORGS_REPORT = getURL('orgs/report');

export const API_ISSUE_GRANT = getURL('orgs/org/users/user/orgs/org/grants/grant');
export const API_USER_DETAILS = getURL("orgs/org/users/user");
export const API_DISABLE_USER = getURL("orgs/org/users/user/disable");
export const API_ACTIVATE_USER = getURL("orgs/org/users/user/activate");
export const API_USERS_REPORT = getURL("users/report");

export const API_SUPPORT_ISSUES = getURL("support/issues");
export const API_SUPPORT_ISSUES_COMPONENTS = getURL("support/issues/components");
export const API_SUPPORT_ISSUE = getURL("support/issues/issue");
export const API_SUPPORT_ISSUE_ATTACHMENT = getURL("support/issues/issue/attachments/attachment");

export const API_CONTRACTS = getURL("contracts/all");
export const API_CONTRACT = getURL("contracts/contract");
export const API_UPLOAD_CONTRACTS = getURL("orgs/org/contracts/contract/netsuite");
export const API_CONTRACTS_REPORT = getURL("contracts/report");

export const API_PACKAGES_SEARCH = getURL("pkgman/packages");
export const API_PACKAGES = getURL("pkgman/packages/all");
export const API_PACKAGE = getURL("pkgman/packages/package");
export const API_VERIFY_PACKAGE = getURL("pkgman/packages/package/verify");
export const API_PACKAGE_DOWNLOAD = getURL('pkgman/packages/package/download');
export const API_PACKAGE_REGISTER = getURL("pkgman/packages/package/register");
export const API_PACKAGE_UPDATE_MD5 = getURL("pkgman/packages/package/update/md5");
export const API_PACKAGE_RESTRICTIONS = getURL("pkgman/packages/package/restrictions");
export const API_PACKAGE_PREREQ = getURL("pkgman/packages/package/prereq");
export const API_PACKAGES_REPORT = getURL("pkgman/packages/report");

export const API_AUDIT_PACKAGES_DOWNLOAD = getURL("audit/packages/download");
export const API_AUDIT_PACKAGES_DOWNLOAD_REPORT = getURL("audit/packages/report/download");

export const PAGE_SIZE = 50;

export const GRANTS = [
    { key: "superadmin", title: "Superadmin", visible: false },
    { key: "admin", title: "Admin", visible: false },
    { key: "member", title: "Member", visible: true },
    { key: "owner", title: "Owner", visible: true },
    { key: "partner", title: "Partner", visible: true },
    { key: "package_tester", title: "Package Tester", visible: false},
    { key: "community_user", title: "Community User", visible: true},
    { key: "support", title: "Support", visible: false}
];

export const privileges = [
    { key: "adminRead", title: "admin read" },
    { key: "adminWrite", title: "admin write" },
    { key: "auditRead", title: "audit read" },
    { key: "jiraRead", title: "jira read" },
    { key: "jiraWrite", title: "jira write" },
    { key: "orgRead", title: "organization read" },
    { key: "orgWrite", title: "organization write" },
    { key: "packageRead", title: "package read" },
    { key: "packageWrite", title: "package write" },
    { key: "shcRead", title: "SHC read" },
    { key: "shcWrite", title: "SHC write" },
    { key: "t4Read", title: "t4 read" },
    { key: "t4Write", title: "t4 write" },
    { key: "userWrite", title: "user write" }
];

export const SYSARCH = [
    { key: "X86", title: "X86" },
    { key: "I64", title: "I64" },
    { key: "AXP", title: "AXP" }
];

export const MINOS = [
    { key: "V8.4-1H1", title: "V8.4-1H1" },
    { key: "V8.4-2", title: "V8.4-2" },
    { key: "V8.4-2L1", title: "V8.4-2L1" },
    { key: "V8.4-2L2", title: "V8.4-2L2" },
    { key: "V8.4-2L3", title: "V8.4-2L3" },
    { key: "V9.2", title: "V9.2" },
    { key: "V9.2-1", title: "V9.2-1" },
    { key: "E9.2-1", title: "E9.2-1" }
];

export const PRODUCTS = [
    { "key": "Accounting", "title": "Accounting" },
    { "key": "BACKUP", "title": "BACKUP" },
    { "key": "Boot Manager", "title": "Boot Manager" },
    { "key": "Cross Tools", "title": "Cross Tools" },
    { "key": "Cross-Build tools", "title": "Cross-Build tools" },
    { "key": "DECnet", "title": "DECnet" },
    { "key": "DECthreads", "title": "DECthreads" },
    { "key": "DECwindows Motif", "title": "DECwindows Motif" },
    { "key": "Documentation", "title": "Documentation" },
    { "key": "Layered Products", "title": "Layered Products" },
    { "key": "MAIL", "title": "MAIL" },
    { "key": "Memory Management", "title": "Memory Management" },
    { "key": "Monitor", "title": "Monitor" },
    { "key": "MSCP", "title": "MSCP" },
    { "key": "Native Compilers", "title": "Native Compilers" },
    { "key": "Native Linker", "title": "Native Linker" },
    { "key": "Open Source", "title": "Open Source" },
    { "key": "Other", "title": "Other" },
    { "key": "SDA", "title": "SDA" },
    { "key": "Shadowing", "title": "Shadowing" },
    { "key": "SYSBOOT", "title": "SYSBOOT" },
    { "key": "SYSGEN", "title": "SYSGEN" },
    { "key": "SYSMAN", "title": "SYSMAN" },
    { "key": "Traceback", "title": "Traceback" },
    { "key": "Virtualization", "title": "Virtualization" },
    { "key": "VMS Clusters", "title": "VMS Clusters" },
    { "key": "VSI TCP/IP", "title":  "VSI TCP/IP" }
];

export const SWTYPES = [
    { key: "d", title: "Documentation"},
    { key: "e", title: "ECO kit"},
    { key: "l", title: "Layered product"},
    { key: "v", title: "OE"},
    { key: "o", title: "Open-source" },
    { key: "p", title: "Patch"},
    { key: "i", title: "Patch Info"}
];

export const KITSTYLE = [
        { key: "p", title: "PCSI" },
        { key: "z", title: "ZIPEXE" },
        { key: "c", title: "ZIP" }
];

export const JIRA_URL = "https://vsi.atlassian.net"

export const YESNO = [
    { key: "1", title: "Yes"},
    { key: "0", title: "No" }
];

export const ECO_RATING = [
    { key: 1, title: 1 },
    { key: 2, title: 2 },
    { key: 3, title: 3 }
];